import { Menu, LogOut, User, Map, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { StatsIndicators } from "./StatsIndicators";

interface MobileMenuProps {
  habitsCount: number;
  adultsCount: number;
  totalStreak: number;
  unreadNotifications: number;
  onOpenPondMap: () => void;
  onOpenProfile: () => void;
  onSignOut: () => void;
  onOpenNotifications: () => void;
}

export const MobileMenu = ({
  habitsCount,
  adultsCount,
  totalStreak,
  unreadNotifications,
  onOpenPondMap,
  onOpenProfile,
  onSignOut,
  onOpenNotifications,
}: MobileMenuProps) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9 md:hidden">
          <Menu className="h-5 w-5" />
          {unreadNotifications > 0 && (
            <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-coral text-[10px] text-white flex items-center justify-center font-bold">
              {unreadNotifications > 9 ? "9+" : unreadNotifications}
            </span>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <span>🐸</span> Menu
          </SheetTitle>
        </SheetHeader>
        
        <div className="mt-6 space-y-6">
          {/* Stats */}
          <div>
            <p className="text-xs text-muted-foreground mb-2">Estatísticas</p>
            <StatsIndicators
              habitsCount={habitsCount}
              adultsCount={adultsCount}
              totalStreak={totalStreak}
              className="justify-start"
            />
          </div>

          {/* Menu items */}
          <div className="space-y-1">
            <Button
              variant="ghost"
              className="w-full justify-start gap-3"
              onClick={onOpenPondMap}
            >
              <Map className="h-4 w-4" />
              Mapa das Lagoas
            </Button>
            
            <Button
              variant="ghost"
              className="w-full justify-start gap-3 relative"
              onClick={onOpenNotifications}
            >
              <Bell className="h-4 w-4" />
              Notificações
              {unreadNotifications > 0 && (
                <span className="ml-auto h-5 w-5 rounded-full bg-coral text-xs text-white flex items-center justify-center font-bold">
                  {unreadNotifications}
                </span>
              )}
            </Button>
            
            <Button
              variant="ghost"
              className="w-full justify-start gap-3"
              onClick={onOpenProfile}
            >
              <User className="h-4 w-4" />
              Perfil
            </Button>
            
            <Button
              variant="ghost"
              className="w-full justify-start gap-3 text-destructive hover:text-destructive"
              onClick={onSignOut}
            >
              <LogOut className="h-4 w-4" />
              Sair
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
